import React from 'react';

import { FormattedMessage } from 'react-intl';

import { DASHBOARD, INSIGHT_PAGES, REPORT } from './constants';
import { ANALYTICS_NAV_ITEMS, LOOKER_PAGES } from './looker';
import messages, { breadcrumbMessages } from './messages';

export const isPathnameOverviewPage = (pathname = '') => {
  return pathname.startsWith(`/${DASHBOARD}`) && (pathname.includes(INSIGHT_PAGES.overview) || pathname === `/${DASHBOARD}`);
};

export const analyticsPages = LOOKER_PAGES.map((p) => {
  return { [p.id]: p.id };
});

export const insightsPages = {
  // pages explicitly in leftnav
  reports: 'reports',
  ...INSIGHT_PAGES,
};

export const InsightsPageNavItemIds = {
  Overview: 'overview',
  Operations: 'operations',
  CustomerEngagement: 'customerEngagement',
  SalesTrends: 'salesTrends',
  CustomerOverview: 'customerOverview',
  ProductHighlights: 'productHighlights',
  Reports: 'reports',
};

export const analyticsNavItems = ANALYTICS_NAV_ITEMS.map((p) => {
  return {
    ...p,
    selected: p?.selected || false,
  };
});

export const insightNavItems = [
  {
    id: InsightsPageNavItemIds.Overview,
    label: <FormattedMessage {...messages.overview} />,
    location: 'overview',
    selected: true,
  },
  {
    id: InsightsPageNavItemIds.Operations,
    label: <FormattedMessage {...messages.operations} />,
    location: 'operations',
  },
  {
    id: InsightsPageNavItemIds.CustomerEngagement,
    label: <FormattedMessage {...messages.customerEngagement} />,
    location: 'tracking',
  },
  {
    id: InsightsPageNavItemIds.SalesTrends,
    label: <FormattedMessage {...messages.salesTrends} />,
    location: 'sales',
  },
  {
    id: InsightsPageNavItemIds.CustomerOverview,
    label: <FormattedMessage {...messages.customerOverview} />,
    location: 'customers',
  },
  {
    id: InsightsPageNavItemIds.ProductHighlights,
    label: <FormattedMessage {...messages.productHighlights} />,
    location: 'products',
  },
  {
    id: InsightsPageNavItemIds.Reports,
    label: <FormattedMessage {...messages.reports} />,
    location: 'reports',
  },
];

const breadcrumbs = {
  reports: {
    message: breadcrumbMessages.dataExports,
    link: `/${DASHBOARD}/${REPORT}`,
  },
  OrderSummary: breadcrumbMessages.orderDetail,
  CountryComparison: breadcrumbMessages.countryComparison,
  BuyerComments: breadcrumbMessages.buyerComments,
  ItemDemandReport: breadcrumbMessages.itemDemandSummary,
  ProductSales: breadcrumbMessages.productSales,
  ProductReturns: breadcrumbMessages.returnedProducts,
  ShipmentCountReport: breadcrumbMessages.shipmentCountByUser,
  ItemsShipped: breadcrumbMessages.shippedItems,
  ShippingCosts: breadcrumbMessages.shippingCost,
  ShippingManifest: breadcrumbMessages.shippingManifest,
  BatchDetail: breadcrumbMessages.batchDetail,
  PostageTransactions: breadcrumbMessages.accountBalanceHistory,
  InvLowStock: breadcrumbMessages.inventoryLowStock,
  InvAuditReport: breadcrumbMessages.inventoryAudit,
  InvOutOfStockShipments: breadcrumbMessages.inventoryOutOfStock,
  InvStock: breadcrumbMessages.inventoryStatus,
  HotkeysReference: breadcrumbMessages.hotkeysReference,
  BarcodeScanActionReport: breadcrumbMessages.barcodeScanAction,
  BarcodeScanQuickReference: breadcrumbMessages.barcodeScanQuickReference,
  Customer: breadcrumbMessages.customers,
  OrderItemExtractReport: breadcrumbMessages.orders,
  ShippingExtract: breadcrumbMessages.shippedOrders,
  ShippingItemExtract: breadcrumbMessages.shippedItemsExtract,
  ProductAliasExtract: breadcrumbMessages.productAliases,
  OrderByLotExtract: breadcrumbMessages.ordersByLot,
};

export const findPageLabelFromLocation = (location) => {
  return breadcrumbs[location];
};
